import React, { useState, useEffect } from "react"
import { PrimeButton } from "components-design-system"

const ArrayTemplate = (props) => {
  const { uiSchema } = props
  const [numOfItems, setNumOfItems] = useState(0)
  const options = uiSchema["ui:options"]
  const title = options && options.title
  const itemTitle = options && options.itemTitle
  const addButtonTitle = options.addButtonTitle
  let styles = options && options.styles

  useEffect(() => {
    if (props.items) {
      setNumOfItems(props.items.length)
    }
  }, [props.items])

  return (
    <div styles={styles && styles.arrContainer}>
      <div style={styles && styles.arrTitle}>
        {title} ({numOfItems})
      </div>
      <div>
        {props.items.map((element) => {
          return (
            <div
              key={element.key}
              style={styles && styles.arrInnerContainer}
            >
              <div style={styles && styles.itemTitle}>{itemTitle}</div>
              {element.hasRemove && (
                <i
                  style={styles && styles.deleteButton}
                  className="fal fa-trash-alt "
                  onClick={element.onDropIndexClick(element.index)}
                />
              )}
              {element.children}
            </div>
          )
        })}
      </div>
      {props.canAdd && (
        <PrimeButton
          type="add"
          onClick={props.onAddClick}
          style={styles && styles.addButton}
        >
          {addButtonTitle}
        </PrimeButton>
      )}
    </div>
  )
}

export default ArrayTemplate
